import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 42); // 14 minutes 42 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 14 * 60 + 42);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-black text-white py-3 z-50 text-center font-bold text-sm md:text-base shadow-lg border-b-4 border-red-600" data-id="element-191">
      <div className="container mx-auto px-4 animate-pulse" data-id="element-192">
        <span className="text-red-500 mr-2" data-id="element-193">⏰</span>
        OFERTA EXPIRA EN:{' '}
        <span className="text-red-500 text-lg mx-1 font-mono" data-id="element-194">
          {formatTime(timeLeft)}
        </span>{' '}
        |<span className="text-yellow-400 ml-2" data-id="element-195">SOLO QUEDAN 3 CUPOS</span>
      </div>
    </div>;
}